<template>
	<div id="app">
		<v-header></v-header>
		<router-view/>
		<v-footer></v-footer>
	</div>
</template>

<script>
//	import Index from './components/index/Index'
	import Header from './components/public/Header'
	import Footer from './components/public/Footer'
	export default {
		name: 'App',
		data() {
			return {}
		},
		components: {
			"v-header": Header,
			"v-footer": Footer

		},
		created() {},
		methods: {}

	}
</script>

<style lang="less">
	@import './assets/css/base.less';
	@import './assets/css/public.less';
	#app {
		width: 100%;
		height: 100%;
	}
</style>


// WEBPACK FOOTER //
// src/App.vue